"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponentManifestBuilder = void 0;
function createComponentManifestBuilder(_a) {
    var name = _a.name;
    var componentManifest = {
        name: name,
        assets: [],
        parts: {},
    };
    return {
        addUrl: function (id, url) {
            componentManifest.id = id;
            componentManifest.url = url;
            this.addModelAsset(id, url);
            return this;
        },
        addPart: function (id, part, url, eager) {
            if (eager === void 0) { eager = false; }
            componentManifest.parts[part] = { id: id, url: url, eager: eager };
            this.addModelAsset(id, url, part);
            return this;
        },
        addModelAsset: function (id, url, part) {
            componentManifest.assets.push({
                id: id,
                url: url,
                type: 'model',
                extension: 'js',
                part: part,
            });
            return this;
        },
        addStyleAsset: function (url, part) {
            componentManifest.assets.push({
                url: url,
                type: 'style',
                extension: 'css',
                part: part,
            });
            return this;
        },
        filterAssets: function (predicate) {
            componentManifest.assets = componentManifest.assets.filter(predicate);
        },
        build: function () {
            return __assign({}, componentManifest);
        },
    };
}
exports.createComponentManifestBuilder = createComponentManifestBuilder;
//# sourceMappingURL=componentsManifestBuilder.js.map